// https://webpack.js.org/guides/dependency-management/#requirecontext
const invoiceapiFiles = require.context('./invoiceapi', true, /\.js$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const invoiceapi = invoiceapiFiles.keys().reduce((invoiceapi, apiPath) => {
  // set './app.js' => 'app'
  const apiName = apiPath.replace(/^\.\/(.*)\.\w+$/, '$1')

  const value = invoiceapiFiles(apiPath)

  invoiceapi[apiName] = value.default

  return invoiceapi
}, {})
export default invoiceapi